import gsap from 'gsap';
import { SECTIONS_IDS } from 'constants/global';

export const startPositionAnimation = () => {
  const tl = gsap.timeline({
    scrollTrigger: {
      trigger: `#${SECTIONS_IDS.startPosition}`,
      end: '+=2500',
      scrub: true,
      pin: true,
      pinSpacing: 'padding',
      invalidateOnRefresh: true,
    },
  });

  tl.to(`#${SECTIONS_IDS.startPosition}-title`, { yPercent: -20, opacity: 0 });
  tl.fromTo(
    `#${SECTIONS_IDS.startPosition}-subtitle`,
    { yPercent: 20, opacity: 0 },
    { yPercent: 0, opacity: 1 },
  );
  tl.to(`#${SECTIONS_IDS.startPosition}-subtitle`, { yPercent: -20, opacity: 0 });
  tl.fromTo(
    `#${SECTIONS_IDS.startPosition}-startLine`,
    { yPercent: 20, opacity: 0 },
    { yPercent: 0, opacity: 1 },
  );
  tl.to(`#${SECTIONS_IDS.startPosition}-startLine`, { yPercent: -20, opacity: 0 });
  tl.fromTo(
    `#${SECTIONS_IDS.startPosition}-cards`,
    { yPercent: 20, opacity: 0 },
    { yPercent: 0, opacity: 1 },
  );
  tl.to(`#${SECTIONS_IDS.flyingButton}`, { pointerEvents: 'none', opacity: 0, duration: 0.5 });
};
